<app-app-loader *ngIf="isLoading"></app-app-loader>
<div class="analyticsPage new" #pageRoot  [style.opacity]="isLoading ? 0 : 1">
    <div class="wrpr">
         <div class="breadCrumbCont">
                    <a class="breadCrumbLink" 
                        routerLink="/analytics" 
                        [ngClass]="{'active': router.url === '/analytics'}">
                        Analytics Home
                    </a>
                    <p>/</p>
                    <a class="breadCrumbLink"
                        routerLink="/all-analytics"
                        [ngClass]="{'active': router.url === '/all-analytics'}">
                        All Analytics
                    </a>
                    <p *ngIf="router.url !== '/analytics' && router.url !== '/all-analytics'">/</p>
                    <a class="breadCrumbLink" style="text-decoration: none;    color: #525252;"
                        *ngIf="router.url !== '/analytics' && router.url !== '/all-analytics'" >
                        {{ dashboard.moduleName }}
                    </a>
                </div>
         <div class="contentCard">
            <p *ngIf="!dashboard">Loading analytics...</p>
            <div class="products colforDetails" *ngIf="dashboard">
                <div class="banner new">
                    <img class="main" [src]="(moduleByteMap[dashboard.moduleName]) | base64: 'image/png'"
                                            alt="power-bi-dashboards-icon" />
                    <p *ngIf="false" class="lastUpdatedStamp"><span><img src="/assets/images/refreshIcon-grey.svg" alt=""></span>Last Refreshed: <span>2hrs ago</span></p>
                    <div class="actionBtnsCont">
                         <button class="secondary" *ngIf="!userId && !isUserLoggedIn"
                                       (click)="onSignIn()">
                                       <img src="/assets/images/locked.svg" alt="">
                                         Request Access
                                    </button>
                                    <button class="primary" *ngIf="dashboard.subscription && userId && isUserLoggedIn" (click)="loadModule(dashboard)">
                                         Open Analytics
                                    </button>
                                  
                                    <button class="secondary"
                                        *ngIf="dashboard.subscription == false&& dashboard.accessCompleted == undefined &&userId &&isUserLoggedIn"
                                        (click)="onRequestAccessClick(dashboard)">
                                        <img src="/assets/images/locked.svg" alt="" style="width: 16px; margin-top: -4px;"/>
                                        Request Access
                                    </button>
                                  
                                    <button class="secondary"
                                        *ngIf="dashboard.subscription == false&& dashboard.accessCompleted != undefined && dashboard.accessCompleted == false && userId &&isUserLoggedIn"
                                        (click)="onAccessPending()">
                                        <img src="/assets/images/locked.svg" alt="" />
                                        Access Pending
                                    </button>
                        <div class="iconBtn">
                            <img (click)="shareLink()" src="/assets/images/copyLink.svg" alt="" style="cursor: pointer;border-radius: 0" />
                        </div>
                        <p id="copyMsg" class="copyMsg" >
                                Link Copied!
                        </p>
                       
                        <div class="iconBtn" *ngIf="userId">
                            <input *ngIf="dashboard.favorite" type="checkbox"
                                [(ngModel)]="dashboard.favorite" class="hidden-checkbox" />
                            <img style="height: 24px; width: 24px; object-fit: none;"  class="addToBook"  (click)="toggleFavourite(dashboard)" [src]="
                                dashboard.favorite
                                    ? '../../../../assets/images/bookmarksIcon-filled.svg'
                                    : '../../../../assets/images/bookmarksIcon.svg'
                                " alt="" />
                        </div>
                    </div>
                </div>
                <div class="productCard detailsCont">
                    <div class="productCardContent flexSP gridForName">
                        <h1>{{ dashboard.moduleName }}</h1>
                        <p *ngIf="dashboard.newlyAdded" class="tag new floating justStart">
                            Newly Added
                        </p>
                    </div>
                    <div class="staticTags flexSP justStart">
                            <p class="tag" *ngFor="let tag of dashboard?.tags" class="tag">
                                {{ tag.tagName }}
                            </p>
                    </div>
                                       
                    <div class="detailGroup">                       
                       <h3>Objective</h3>
                       <div [innerHTML]="dashboard.moduleLongDescription"></div>                                            
                    </div>

                    <div class="detailGroup staticTags">
                        <h3>Features</h3>
                        <div class="featureGrid">
                            <p class="tag" *ngFor="let feature of dashboard?.features">
                                <span><img src="/assets/images/Check.svg" alt="" /></span>{{ feature }}
                            </p>
                        </div>
                    </div>

                    <div class="supportCont">
                        <div class="flexSP justStart">
                            <div class="sectionHead">
                                <h2>Need more details?</h2>
                                <p>Connect with the dashboard owner</p>
                                <img style="cursor: pointer;" (click)="redirectToEmail()" src="/assets/images/contactOwnerMail.svg" alt="" />
                            </div>
                            <!-- <img  src="/assets/images/contactOwnerTeams.svg" alt="" /> -->
                            <button style="display: none;" [disabled]="true" class="secondary">REQUEST DEMO</button>
                        </div>

                        <img src="/assets/images/dmint_customer_care_illiustration.svg" class="illus" alt="" />
                    </div>
                </div>
            </div>
            <div class="recommendedDashboards">
                <h2>Similar Analytics</h2>
                 <div class="noResults" *ngIf="visibleCards?.length == 0">
                    <img src="/assets/images/noResults.png" alt="no-results" />
                    <p>No results found.</p>
                 </div>
                <div class="recommendedGrid" *ngIf="visibleCards?.length > 0">
                    <button (click)="prev()" [disabled]="currentIndex === 0" class="arrowBtn">
                        <img src="/assets/images/chevron-south.svg" alt="" style="transform: rotate(90deg)" />
                    </button>

                    <div class="recommendedCard" *ngFor="let similarDashboard of visibleCards">
                        <h3>{{ similarDashboard.moduleName }}</h3>
                        <button class="dmintLinkBtn" (click)="viewDetails(similarDashboard)">
                            View Details
                        </button>
                    </div>

                    <button (click)="next()" [disabled]="(currentIndex + 1) * pageSize >= dashboard?.similarDashboards?.length" class="arrowBtn right">
                    <img src="/assets/images/chevron-south.svg" alt="" style="transform: rotate(-90deg)" />
                    </button>
                </div>
            </div>
        </div>
       </div>
</div><app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>